<script lang="ts">
	import { clickOutside } from '$lib/components/ClickOutside/clickOutside.js'

	export let isMinimal = false
	export let widthDividers = false
	export let menuExpanded = false
	export let toRight = true
	export let selectName = 'Select'

	let invalidateSelect = false

	// let menuButtonClass = 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500'
	// let menuButtonClass = 'focus:outline-none focus:ring-1 focus:ring-offset-0 focus:ring-offset-gray-100'
	// let menuButtonClass = 'focus:outline-none focus:ring-1 focus:ring-offset-0 focus:ring-offset-gray-100'
	// let menuButtonClass = 'focus-visible:ring-2 focus:ring-offset-2  focus-visible:ring-offset-red-400'
	let menuButtonClass = 'focus:outline-none focus:ring-1 focus:ring-offset-0 focus:ring-offset-gray-100 focus:ring-gray-500'

	$: menuItemsClass = widthDividers ? 'divide-y divide-gray-100' : ''
	$: menuItemsStyle = !menuExpanded ? 'display: none;' : ''
	// $: console.log('MoreActions - widthDividers: %s', widthDividers);
	// $: console.log('MoreActions - menuItemsClass: %s', menuItemsClass);
	$: classPosition = toRight ? 'right-0' : 'left-0'

	function handleToogleMenu() {
		if(invalidateSelect) {
			invalidateSelect = false
			return
		}
		menuExpanded = !menuExpanded
	}
	function handleClickOutside() {
		if (menuExpanded) {
			menuExpanded = false
			invalidateSelect = true
		}
	}
</script>

<!-- <svelte:window on:mousedown={handleClickOutside} /> -->

<!-- This example requires Tailwind CSS v2.0+ -->
<div class="relative inline-block text-left">
	<div>
		<div>
			{#if isMinimal}
				<button
					type="button"
					data-test-id="more_action_toggle_menu"
					on:click|preventDefault|stopPropagation={() => handleToogleMenu()}
					class="bg-white rounded-full flex items-center text-gray-400 hover:text-gray-600 {menuButtonClass}"
					id="menu-button"
					aria-expanded="true"
					aria-haspopup="true"
				>
					<!-- class="bg-gray-100 rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" id="menu-button" aria-expanded="true" aria-haspopup="true"> -->
					<span class="sr-only">Open options</span>
					<!-- Heroicon name: solid/dots-vertical -->
					<svg
						class="h-5 w-5"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						aria-hidden="true"
					>
						<path
							d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
						/>
					</svg>
				</button>
			{:else}
				<button
					type="button"
					data-test-id="more_action_toggle_menu"
					on:click|preventDefault|stopPropagation={() => handleToogleMenu()}
					class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 {menuButtonClass}"
					id="menu-button"
					aria-expanded="false"
					aria-haspopup="false"
				>
					<!-- class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" id="menu-button" aria-expanded="false" aria-haspopup="false"> -->
					{selectName}
					<!-- Heroicon name: solid/chevron-down -->
					<svg
						class="-mr-1 ml-2 h-5 w-5"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
						fill="currentColor"
						aria-hidden="true"
					>
						<path
							fill-rule="evenodd"
							d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
							clip-rule="evenodd"
						/>
					</svg>
				</button>
			{/if}
		</div>

		<!--
			Dropdown menu, show/hide based on menu state.
	
			Entering: "transition ease-out duration-100"
			From: "transform opacity-0 scale-95"
			To: "transform opacity-100 scale-100"
			Leaving: "transition ease-in duration-75"
			From: "transform opacity-100 scale-100"
			To: "transform opacity-0 scale-95"
		-->
		{#if (menuExpanded)}
			<div
				class="z-50 origin-top-right absolute {classPosition} mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none {menuItemsClass} "
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="menu-button"
				tabindex="-1"
				style={menuItemsStyle}
				use:clickOutside
				on:clickOutside={handleClickOutside}
			>
				<slot />
			</div>
		{/if}
	</div>
</div>
